import { useState } from 'react';
import { IconDown, IconUp } from '@ui/src';
import CardItem from './card-item';
import { CardType, CustomerType } from '../../../hoc/customers/types';
import { CardsListTypes } from './types';

import cn from './cards.module.css';

const CardsList = ({
  cards,
  onStatusChange,
  updatedCard,
  statusChangeInProgress,
  customerType,
  customerId,
  changeStatusInProgress,
  changeStatusSuccess,
}: CardsListTypes) => {
  const [corporateCardsVisible, setCorporateCardsVisible] = useState(false);

  let nextCards;

  if (customerType === CustomerType.INDIVIDUAL) {
    nextCards = cards?.filter((item) => item.type === CardType.DEBIT);
  } else {
    nextCards = cards?.filter((item) => item.type === CardType.CORP);
  }

  const corpCards = cards?.filter((item) => item.type === CardType.CORP);

  return (
    <>
      {nextCards.map((item, index) => (
        <CardItem
          key={item.id}
          card={item}
          onStatusChange={onStatusChange}
          updatedCard={updatedCard}
          statusChangeInProgress={statusChangeInProgress}
          customerId={customerId}
          zIndex={nextCards.length - index}
          changeStatusInProgress={changeStatusInProgress}
          changeStatusSuccess={changeStatusSuccess}
          customerType={customerType}
        />
      ))}
      {customerType === CustomerType.INDIVIDUAL && corpCards?.length > 0 && (
        <>
          <button
            type="button"
            className={cn.corpCardsButton}
            onClick={() => setCorporateCardsVisible(!corporateCardsVisible)}
          >
            {`${corpCards.length} corporate cards`}
            {corporateCardsVisible ? (
              <IconUp className={cn.corpCardsButtonIcon} />
            ) : (
              <IconDown className={cn.corpCardsButtonIcon} />
            )}
          </button>
          {corporateCardsVisible &&
            corpCards.map((item, index) => (
              <CardItem
                key={item.id}
                card={item}
                onStatusChange={onStatusChange}
                updatedCard={updatedCard}
                statusChangeInProgress={statusChangeInProgress}
                customerId={customerId}
                zIndex={corpCards.length - index}
                changeStatusInProgress={changeStatusInProgress}
                changeStatusSuccess={changeStatusSuccess}
                customerType={customerType}
              />
            ))}
        </>
      )}
    </>
  );
};

export default CardsList;
